import { PLATFORM_STYLES, DEFAULT_PLATFORM_STYLE } from '../data/constants'

/**
 * Coloured pill badge showing which platform the deal belongs to.
 * @param {{ platform: string }} props
 */
const PlatformBadge = ({ platform }) => {
  const style = PLATFORM_STYLES[platform] ?? DEFAULT_PLATFORM_STYLE

  return (
    <span
      className={`
        inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full
        text-xs font-semibold border
        ${style.bg} ${style.text} ${style.border}
      `}
    >
      <span className={`w-1.5 h-1.5 rounded-full ${style.dot}`} aria-hidden="true" />
      {platform}
    </span>
  )
}

export default PlatformBadge
